import React, { useState } from 'react';
import { Table, Card, CardBody, Badge } from "reactstrap";


// Import Images
import user2 from "../../assets/images/users/user-2.jpg";
import user3 from "../../assets/images/users/user-3.jpg";
import user4 from "../../assets/images/users/user-4.jpg";
import user5 from "../../assets/images/users/user-5.jpg";
import user6 from "../../assets/images/users/user-6.jpg";
import moment from 'moment';

const LatestTransactions = ({latest}) => {

  return (
    <React.Fragment>
      <Card>
        <CardBody>
          <h4 className="card-title mb-4">5 dernières demandes</h4>

          <div className="table-responsive">
            <Table className="align-middle table-centered table-vertical table-nowrap">
              <tbody>
                {latest.map((item, key) => (
                  <tr key={key}>
                    <td>
                      {item.clt.nom}
                    </td>
                    <td>
                      {/* <img
                        src={user2}
                        alt="user"
                        className="avatar-xs rounded-circle me-2"
                      />{" "} */}
                      {item.operation.code}
                    </td>
                    <td>
                      {item.stat==0 ? (<Badge className={"rounded-pill bg-danger"}>En attente</Badge>):
                      item.stat==1 ? (<Badge className={"rounded-pill bg-warning"}>Confirmé</Badge>):
                      item.stat==2 ? (<Badge className={"rounded-pill bg-info"}>En cours</Badge>):
                      (<Badge className={"rounded-pill bg-success"}>Livré</Badge>)
                      }
                    </td>
                    <td>
                      {moment(item.create).format("DD-MM-YY HH:mm")}
                    </td>
                  </tr>
                ))}
              </tbody>
            </Table>
          </div>
        </CardBody>
      </Card>
    </React.Fragment>
  );
};

export default LatestTransactions;
